<template>
  <div class="progress-container" ref="progressContainer" :style="progressContainerStyle">
    <div :class="progressBarClass()" :style="progressStyle"></div>
  </div>
  <svg :width="progressContainerWidth" :height="progressObj.height" :style="progressSvgStyle">
    <defs>
      <mask :id="domId">
        <rect
          x="0"
          y="0"
          :width="progressBarWidth"
          :height="progressObj.height"
          :rx="progressObj.borderRadius"
          :ry="progressObj.borderRadius"
          fill="white"
        />
      </mask>
    </defs>
  </svg>
</template>

<script lang="ts" setup>
import { computed, inject, ref, watch } from "vue"
import { v4 } from "uuid"
const domId = ref(`uuid_${v4()}`)

const progressContainer = ref<HTMLDivElement>()

const props = defineProps<{
  rank: any
  data: number
  containerStyle?: any
  style?: any
}>()

const progressObj = computed(() => {
  if (props.style?.height) {
    const height = Number(props.style?.height?.replace("px", ""))
    return {
      height,
      borderRadius: height / 2,
    }
  } else {
    return {
      height: 8,
      borderRadius: 4,
    }
  }
})

const progressContainerStyle = ref<{ [key: string]: string }>({})

watch(
  () => progressObj.value,
  () => {
    progressContainerStyle.value = {}
    if (props.containerStyle) {
      progressContainerStyle.value = props.containerStyle
    }
    progressContainerStyle.value.height = `${progressObj.value.height}px`
    progressContainerStyle.value.borderRadius = `${progressObj.value.borderRadius}px`
  },
  {
    immediate: true,
    deep: true,
  },
)

console.log("progressContainerStyle", progressContainerStyle)

const progressContainerWidth = computed(() => {
  return progressContainer.value?.clientWidth
})

const progressBarWidth = computed(() => {
  if (!progressContainerWidth.value) return 0
  return (progressContainerWidth.value * props.data) / 100
})

const progressSvgStyle: any = computed(() => {
  return {
    position: "absolute",
    opacity: 0,
  }
})

const progressStyle = computed(() => {
  return {
    mask: `url(#${domId.value})`,
    "-webkit-mask": `url(#${domId.value})`,
    ...props.style,
  }
})

const progressBarClass = () => {
  const classObj = {
    "progress-bar": true,
  }
  if (props.rank === 1) {
    classObj["glod"] = true
  } else {
    classObj["blue"] = true
  }
  return classObj
}
</script>

<style lang="scss" scoped>
.progress-container {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  overflow: hidden;
  background: rgba(56, 112, 212, 0.1);
}

.progress-bar {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(56, 112, 212, 0.5) 0%, #2bb7f7 100%);
  // mask: linear-gradient(to right, #000 0, #000 var(--progress), transparent var(--progress), transparent 100%);
  // -webkit-mask: linear-gradient(to right, #000 0, #000 var(--progress), transparent var(--progress), transparent 100%);

  &.glod {
    background: linear-gradient(90deg, rgba(213, 162, 50, 0.5) 0%, #fcf072 100%);
  }
  &.blue {
    background: linear-gradient(90deg, rgba(56, 112, 212, 0.5) 0%, #2bb7f7 100%);
  }
}
</style>
